module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000297-e8b64d6f68a35d90ba8c0877c1bbf0bd.pdf";